var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultBankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    stroke: "#D8DFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61144 22.2593V13.3154H21.8039V22.2436C21.8039 22.3061 21.8039 22.3686 21.8039 22.4233C21.8039 22.5092 21.8192 22.5795 21.7121 22.5795C20.9389 22.5795 20.1734 22.5795 19.4002 22.5795H8.42288C8.17792 22.5795 7.94061 22.5795 7.69565 22.5795C7.58848 22.5795 7.61144 22.5249 7.61144 22.4311V22.2671V22.2593Z",
    stroke: "#5783BD",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3427 12.0185V12.982C23.3427 13.1673 23.1743 13.3155 22.9752 13.3155H6.56276C6.35607 13.3155 6.19531 13.1673 6.19531 12.982V12.0185C6.19531 11.8999 6.26421 11.7962 6.37138 11.7369L14.5776 7.05296C14.7001 6.98625 14.8532 6.98625 14.968 7.05296L23.1743 11.7369C23.2814 11.7962 23.3503 11.9073 23.3503 12.0185H23.3427Z",
    stroke: "#5783BD",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8372 22.5713H5.99609",
    stroke: "#5783BD",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 13.332V22.5181",
    stroke: "#5783BD",
    strokeWidth: 1.10778
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.332V22.5181",
    stroke: "#5783BD",
    strokeWidth: 1.10778
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBankIcon);
export default __webpack_public_path__ + "static/media/DefaultBankIcon.9f145746720762ba1dd1131f1fb03467.svg";
export { ForwardRef as ReactComponent };